export default "__VITE_ASSET__rWNRaltl__"